export default __webpack_public_path__ + "static/media/img-12.f676005a.jpg";